export default __webpack_public_path__ + "static/media/CNDL.bb0c087f.webp";